<div class="row mt-2 px-4">
  <div class="col p-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-header transparent  text-muted">

        <div class="row mt-1">
          <div class="col-6">
            <div class="col-lg-10 col-6 d-flex mb-2">
              <label class="label-font col-lg-4 col-6">Bank Routing</label>

              <div class="input-group my-group  mx-auto">
                <input class="form-control" [type]="bankRoutePassword" id="bankRountingPayroll" name="bankrouting"
                  [(ngModel)]="employeePayrollinformationBO.bankRounting">
                <!-- <button class="btn btn-edit-table text-center ms-2"  (click)="setfieldName('Bank Routing')"  data-bs-toggle="modal" data-bs-target="#showaccountnumberbankrouting" [disabled]="employeePayrollinformationBO.bankRounting==null||employeePayrollinformationBO.bankRounting==''||employeePayrollinformationBO.bankRounting==undefined" ><i
                  class="fa fa-eye"></i></button>       -->
                <i class="fa fa-eye icon_settings" *ngIf="show_bankrout"
                  (click)="show_bankrout=false; show_bankroutfun()"></i>
                <i class="fa fa-eye-slash icon_settings" *ngIf="!show_bankrout"
                  (click)="show_bankrout=true;show_bankroutfun()"></i>
              </div>
            </div>
            <div class="col-lg-10 col-6 d-flex mb-2">
              <label class="label-font col-lg-4 col-6">Account Number</label>

              <div class="input-group my-group  mx-auto">
                <input class="form-control" [type]="Password" name="accountnumber" id="accountnumberPayroll"
                  [(ngModel)]="employeePayrollinformationBO.accountNumber">

                <i class="fa fa-eye icon_settings" *ngIf="show_pass" (click)="show_pass = false; showPass(); "></i>
                <i class="fa fa-eye-slash icon_settings" *ngIf="!show_pass" (click)="show_pass = true; showPass();"></i>

                <!-- <button class="btn btn-edit-table text-center ms-2"  (click)="setfieldName('Account Number')" data-bs-toggle="modal" data-bs-target="#showaccountnumberbankrouting" [disabled]="employeePayrollinformationBO.accountNumber==null||employeePayrollinformationBO.accountNumber==undefined||employeePayrollinformationBO.accountNumber==''" >
                <i
                   class="fa fa-eye"></i></button>                -->

              </div>
            </div>
            <div class="col-lg-10 col-6 d-flex mb-2">
              <label class="label-font col-lg-4 col-6">Exemption Number</label>
              <input class="form-control" type="text" [(ngModel)]="employeePayrollinformationBO.exemptionsNumber">
            </div>
            <div class="col-lg-10 col-6 d-flex mb-2">
              <label class="label-font col-lg-4 col-6">Other Payroll Info</label>
              <input class="form-control" type="text" [(ngModel)]="employeePayrollinformationBO.otherPayrollInfo">
            </div>

            <div class="col-lg-10 col-6 d-flex mb-2">
              <label class="label-font col-lg-4 col-6">All Company Payroll ID#</label>
              <input class="form-control" type="text" [(ngModel)]="employeePayrollinformationBO.allCompanyPayrollID">
            </div>
          </div>
          <div class="row col-6">
            <div class="col-6">
              <h6 class="mb-2  fw-bold fs-5">WithHolding</h6>
              <hr class="mt-0 col-10">
              <div class="row pt-1" *ngFor="let with of MaritialStatus">
                <div class="col mb-2">
                  <input type="radio" name="radio1" [(ngModel)]="employeePayrollinformationBO.withHoldingLid"
                    [value]="with.id"> <span class="label-font ms-2">{{with.lovName}}</span>
                </div>
              </div>
            </div>
            <!-- ............................................ -->
            <div class="col-6">
              <h6 class="mb-2  fw-bold fs-5">Paycheck Type</h6>
              <hr class="mt-0 col-10">
              <div class="row pt-1" *ngFor="let with of PayCHeckType">
                <div class="col mb-2">
                  <input type="radio" name="radio2" [(ngModel)]="employeePayrollinformationBO.paycheckTypeLid"
                    [value]="with.id"> <span class="label-font ms-2">{{with.lovName}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- .................................... -->

        <!-- ......................................... -->
        <div class="row col-12">
          <div class="col pt-2 text-end">
            <button class="btn_m" (click)="SaveEmployeePayroll()" [disabled]="global.viewTabs || isDisabled"
              *ngIf="fp.payrollinfosave">
              Save</button>
          </div>
        </div>

        <!-- .....................................WORK HIStORY.......................................................... -->
        <div class="row pt-3">
          <div class="col ">
            <h4 class="fw-bold">Work History</h4>
            <div class="row pt-1 ">
              <div class="col">
                <button type="button" class="btn_m mt-3" data-bs-toggle="modal" data-bs-target="#keystatusmodalopen"
                  [disabled]="global.viewTabs" (click)=" dateCreateupdate('new')" *ngIf="fp.payrollinfocreate">Key
                  Status/Dates</button>
              </div>
              <!-- .........................class="mb-0 font-header fw-bolder"...............................grid......................... -->
              <div class="row  mt-5">
                <h4 class="fw-bold">Hiring /Termination History</h4>
              </div>
              <div class="row mb-2 mt-1 pt-1">
                <div class="col pl-0">
                  <ejs-grid #grid [dataSource]='data | async' [allowResizing]='true' [pageSettings]='initialPage'
                    [filterSettings]='filterOptions' [allowSorting]='true' [showColumnChooser]='true' allowPaging='true'
                    (actionBegin)="onActionComplete($event)" (dataStateChange)='dataStateChange($event)'>
                    <e-columns>
                      <e-column minWidth=100 uid="action" headerText="Actions" textAlign="center"
                        [showInColumnChooser]='false'>
                        <ng-template #template let-data>
                          <button class="btn btn-edit-table" data-bs-toggle="modal" data-bs-target="#keystatusmodalopen"
                            (click)="edittype(data);dateCreateupdate('edit')" *ngIf="fp.payrollinfoupdate"><i
                              class="fa fa-edit"></i></button>&nbsp;
                        </ng-template>
                      </e-column>
                      <e-column minWidth=100 field="clientName" headerText="Client Name">
                        <ng-template #filterTemplate let-data>
                          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                      </e-column>
                      <e-column minWidth=100 field="hireDate" headerText="Hire Date" type="date"
                        [format]="formatOptions">
                        <ng-template #filterTemplate let-data>
                          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                      </e-column>
                      <e-column minWidth=100 field="inactiveDate" headerText="inactive Date" type="date"
                        [format]="formatOptions">
                        <ng-template #filterTemplate let-data>
                          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                      </e-column>
                      <e-column minWidth=100 field="termDate" headerText="Termination Date" type="date"
                        [format]="formatOptions">
                        <ng-template #filterTemplate let-data>
                          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                        </ng-template>
                      </e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--------------------------------------------------Keys status and Dates--------------------------------------------->


<span id="openModal1" data-bs-target="#keystatusmodalopen" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="keystatusmodalopen" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="false">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="ModelType =='new'">Key Status/Date</h5>
        <h5 class="modal-title font-header" id="exampleModalLabel" *ngIf="ModelType =='edit'">Update Key Status/Date
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row mb-1">
          <div class="col-lg-6">
            <label class="label-font">Client</label>
          </div>
          <div class="col-lg-6">
            <ng-select class="width25" [searchable]="true" [items]="ClientDropdown" [clearable]="true" bindLabel="Value"
              bindValue="Key" [(ngModel)]="employeeworkhistoryBO.clientId">
            </ng-select>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <label class="label-font"> Hire Date <sup class="super-script">*</sup> </label>
          </div>
          <div class="col-lg-6">
            <my-date-picker class="col" [selDate]="employeeworkhistoryBO.hireDate" [options]="myDatePickerOptions"
              placeholder="mm/dd/yyyy" (inputFieldChanged)="DateFormat($event,'inputchanged','HireDate')"
              (dateChanged)="DateFormat($event,'datechanged','HireDate')" disabled></my-date-picker>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <label class="label-font"> Inactive Date</label>
          </div>
          <div class="col-lg-6">
            <my-date-picker class="col" [selDate]="employeeworkhistoryBO.inactiveDate" [options]="myDatePickerOptions"
              placeholder="mm/dd/yyyy" (inputFieldChanged)="DateFormat($event,'inputchanged','InactiveDate')"
              (dateChanged)="DateFormat($event,'datechanged','InactiveDate')" disabled></my-date-picker>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <label class="label-font"> Term Date</label>
          </div>
          <div class="col-lg-6">
            <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
              [selDate]="employeeworkhistoryBO.termDate"
              (inputFieldChanged)="DateFormat($event,'inputchanged','TermDate')"
              (dateChanged)="DateFormat($event,'datechanged','TermDate')"> </my-date-picker>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" *ngIf="ModelType =='new'" (click)="saveemployeeworkhistory('new');"
          [disabled]="(employeeworkhistoryBO.hireDate==''||employeeworkhistoryBO.hireDate==undefined || isDisabled)">Save &
          Close </button>

        <button type="button" class="btn btn-sm" *ngIf="ModelType =='edit'" (click)="saveemployeeworkhistory('edit');"
          [disabled]="(employeeworkhistoryBO.hireDate==''||employeeworkhistoryBO.hireDate==undefined || isDisabled)">
          Update & Close </button>
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>



<span id="openShowPass" data-bs-target="#showaccountnumberbankrouting" data-bs-toggle="modal"></span>
<div class="modal hide modalbackgrod" id="showaccountnumberbankrouting" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          Show {{filedname}}
        </h5>
        <button type="button" class="btn-close" (click)=closeeyeicon() data-bs-dismiss="modal">
        </button>
      </div>

      <div class="modal-body">
        <form [formGroup]="showPassAccountRouting">
          <div class="row mb-2">
            <div class="col-lg-4">
              <label style="font-weight: 600; margin-top: 6px">Password<sup
                  style="color: red; font-size: 1.35em; top: 0em">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-5">
              <input type="password" class="form-control" formControlName="Password" [(ngModel)]="admin_Password"
                (keyup)="passvalid($event)" />
              <div *ngIf="
          showPassAccountRouting.controls['Password'].invalid &&
          (showPassAccountRouting.controls['Password'].dirty ||
            showPassAccountRouting.controls['Password'].touched)
        " class="alert alert-danger" style="height: 30px; margin-top: 10px">
                <div *ngIf="showPassAccountRouting.controls['Password'].errors.required">
                  Password is required.
                </div>
              </div>
              <!-- <div *ngIf="showPassAccountRouting.controls['Password'].valid"
                                class="alert alert-danger">
                                <div>Enter Valid Password</div>
                            </div> -->
            </div>
          </div>
        </form>
        <!-- <div class="row">
                      <div class="col-lg-4">
                        
                        <label style="font-weight: 600; margin-top: 6px">{{filedname}}</label>                      
                        </div>
                        <div class="col-lg-5">
                          <input type="text" class="form-control" 
                          [(ngModel)]="showedString"  disabled/>
                           <label class="label-font mt-2">{{showedString}}</label> -->
        <!-- </div> -->
        <!-- </div> -->


      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" [disabled]="!showPassAccountRouting.valid" (click)="showRoutingAcct()">
          Show
        </button>
        <button type="button" class="btn btn-sm" data-bs-dismiss="modal" data-bs-target="#modal"
          (click)="closeeyeicon()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>